<template>
  <div page_id="page-apply-tradeAccount">
    <bLoading class="allLoading" :loading="allLoading"></bLoading>
    <div v-show="allLoading===false" class="account-application">
      <bCardHeader :param="param"></bCardHeader>
      <keep-alive>
        <component
          v-bind:is="currentTabComponent"
          :status="status"
          :tradeAccountType="tradeAccountType"
          :remark="remark"
          :tradeAccountNumber="tradeAccountNumber"
          @createAccount="createAccount"
          v-loading="isLoading"
        />
      </keep-alive>
      <bDialog :dialogVisible.sync="isCodeShow"
               :params="orderId"
               :component="componentDialog"
               :showClose="showClose"
               page_id = "page_tradeAccount_dialog"
               @closeChange="closeChange"
               :contiune="contiune"
               >
               </bDialog>
    </div>
  </div>

</template>

<script>

import { mapGetters, mapState } from 'vuex'
import complete from '../fund-transfer/info-dialog.vue'
// import proxyApi from '@/api/proxy-api'
import defaultApplyForm from './components/defaultApplyForm'
import mt5ApplyForm from './components/mt5ApplyForm'
import fdmtApplyForm from './components/fdmtApplyForm'
import securitiesMarginApplyForm from './components/securitiesMarginApplyForm'
import api from '@/api/v2/trade'
export default {
  components: { defaultApplyForm, mt5ApplyForm, fdmtApplyForm, securitiesMarginApplyForm },
  computed: {
    ...mapGetters(['getUser', 'getClientProfile', 'getAccountInfo', 'getClientProfile', 'selectLang']),
    ...mapState(['tradeAccountList', 'rejectRecords']),
    currentTabComponent () {
      const options = {
        MT5: 'mt5ApplyForm',
        SECURITIES_MARGIN: 'securitiesMarginApplyForm'
      }
      let showComponent = options[this.$route.query.tradeAccountType]
      return showComponent || 'defaultApplyForm'
    }
  },
  data () {
    return {
      orderId: {},
      isLoading: false,
      type: this.$route.query.type,
      tradeAccountType: this.$route.query.tradeAccountType,
      remark: this.$route.query.remark,
      status: this.$route.query.status,
      tradeAccountNumber: this.$route.query.tradeAccountNumber,
      dialogVisible: false,
      isCodeShow: false,
      loading: false,
      showClose: true,
      contiune: true,
      componentDialog: complete,
      form: {},
      allLoading: status === 'reject',
      param: {
        title: 'other_account',
        links: [{
          title: 'home'
        },
        {
          title: 'my_account'
        },
        {
          title: 'other_account'
        }
        ]
      },
      formType: ''
    }
  },
  methods: {
    closeChange () {
      this.$router.replace({
        path: '/other-account'
      })
    },
    checkReConfirmInfo (reConfirmInfo) {
      let flag = true
      if (!reConfirmInfo.experience) {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.pleaseSelectInvestmentExperience')}`)
      }
      if (reConfirmInfo.purpose.length === 0) {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.pleaseSelectPurposeOfInvestment')}`)
      }
      if (reConfirmInfo.isShowYears) {
        if (reConfirmInfo.employerNumber === '') {
          flag = false
          return this.errorTips(`${this.$t('applyTradeAccount.employmentYearsEnter')}`)
        }
        if (Number(reConfirmInfo.employerNumber) === 0 || Number(reConfirmInfo.employerNumber) > 100) {
          flag = false
          return this.errorTips(`${this.$t('applyTradeAccount.employmentYearsError')}`)
        }
      // 正整数
        let reg = /^[+]{0,1}(\d+)$/
        if (reConfirmInfo.employerNumber && !reg.test(reConfirmInfo.employerNumber)) {
          flag = false
          return this.errorTips(`${this.$t('applyTradeAccount.yearsError')}`)
        }
        // 不能0开头
        let reg2 = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/
        if (reConfirmInfo.employerNumber && !reg2.test(reConfirmInfo.employerNumber)) {
          flag = false
          return this.errorTips(`${this.$t('applyTradeAccount.notZeroFirst')}`)
        }
      }
      if (!reConfirmInfo.checked1) {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.pleaseComfirmInfo')}`)
      }
      if (!reConfirmInfo.checked2) {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.pleaseReadText')}`)
      }
      if (!reConfirmInfo.checked3) {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.pleaseReadText')}`)
      }
      // 检查投资目标 申请杠杆式外汇交易账详情页面，投资目标只选择"利息/股息收入"，不能提交申请
      if (reConfirmInfo.purpose.length === 1 && reConfirmInfo.purpose[0] === 'income') {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.purposeOfInvestmentTips')}`)
      }
      // 检查风险承受能力 申请杠杆式外汇交易账详情页面，"您的风险承受能力是"选择"中"或者"低"，不能提交申请
      if (['medium', 'low'].includes(reConfirmInfo.riskTolerance)) {
        flag = false
        return this.errorTips(`${this.$t('applyTradeAccount.errTips.riskToleranceTips')}`)
      }

      return flag
    },
    async createAccount (params) {
      try {
        if (params.ruleForm) {
          const flag = await this.checkReConfirmInfo(params.ruleForm)
          if (!flag) {
            return
          }
        }
        let data = {
          agreement: params.agree,
          infoIsSame: params.infoIsSome === 'yes',
          submitSource: 'CP_WEB',
          tradeAccountType: this.tradeAccountType,
          investment: params.ruleForm,
          relatedMarginAccounts: params.relatedMarginAccounts,
          futuresCognize: params.futuresCognize
          // 'type': this.type,
          // 'tradeAccountType': this.tradeAccountType,
          // 'agree': params.agree,
          // 'infoIsSome': params.infoIsSome,
          // 'sourceType': 'clientPortal',
          // 'reConfirmInfo': params.ruleForm
        }
        if (['FUTURES_DAYTRADING_MARGIN', 'FUTURES_MARGIN'].includes(this.tradeAccountType)) {
          data.investmentInfo = params.investmentInfo
        }
        if (this.tradeAccountType === 'MT5') {
          let purposeStr
          purposeStr = JSON.stringify(params.ruleForm.purpose)
          data.investment.purpose = purposeStr
        }
        // if (params.aboutMargin) Object.assign(data, { aboutMargin: params.aboutMargin })
        // console.log('data>>>>>>>', data)
        this.isLoading = true
        let result = await api.commitTradeAccount(data)
        this.isLoading = false
        if (result.code === 200) {
          this.orderId = { orderId: result.data.orderId }
          this.isCodeShow = true
        } else {
          return this.errorTips(this.$t(`applyTradeAccount.requestError.${result.message}`))
        }
      } catch (error) {
        this.isLoading = false
        // return this.errorTips(this.$t(`errMessage.500`))
      }
    },
    errorTips (text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'error'
      })
    }

  }
}

</script>

<style lang="scss">

</style>
